<template>
    <returnButton class="return-button" />
    <div class="main-container">
        <patientInfo :selectedPatientId="selectedPatientId" />
        <h2 class="titulos" style="text-align: center">Creación de notas</h2>
        <v-form ref="formulario" v-model="inputNoteForm">
            <v-row>
                <v-col cols="12" md="12">
                    <v-textarea
                        no-resize
                        no-gutters
                        v-model="note"
                        label="Nota(s)"
                        variant="outlined"
                        rows="3"
                        :rules="reglasValidacion"
                        required>
                        <!-- @input="sanitizarInput" -->
                        <template #prepend>
                            <v-icon>mdi mdi-note-text-outline</v-icon>
                        </template>
                    </v-textarea>
                </v-col>
            </v-row>
            <v-row class="justify-end" style="margin-right: 0px">
                <button
                    class="button boton-principal font"
                    @click="createNote()"
                    :disabled="!inputNoteForm || isSubmitting">
                    <v-icon left>mdi-content-save</v-icon> Guardar nota
                </button>
            </v-row>
        </v-form>
        <h2 class="titulos" style="text-align: center">Notas</h2>
        <v-row v-if="snackbarMessage">
            <v-col>
                <div class="error-message">
                    {{ snackbarMessage }}
                </div>
            </v-col>
        </v-row>
        <v-row v-else>
            <div class="notes-container">
                <div
                    v-for="(note, index) in paginatedData"
                    :key="index"
                    class="note-item"
                    :class="{
                        'cancelled-note': note.status === 'cancelled',
                    }">
                    <div class="note-header">
                        <div class="info-group">
                            <div class="practitioner-id">Médico:</div>
                            <span class="info-text">{{
                                note.practitioner ?? note.practitioner_id
                            }}</span>
                        </div>
                    </div>
                    <div class="note-content">
                        <p>{{ note.note }}</p>
                    </div>
                    <div class="note-footer">
                        <span class="date">{{
                            formatDate(note.created_at)
                        }}</span>
                        <button
                            v-if="note.practitioner_id == this.practitionerId"
                            class="cancel-button"
                            @click="openDialog(index)"
                            :disabled="note.status === 'cancelled'">
                            {{
                                note.status === 'cancelled'
                                    ? 'Cancelada'
                                    : 'Cancelar'
                            }}
                        </button>
                        <v-dialog v-model="dialogNote" persistent>
                            <v-row justify="center">
                                <v-card class="h-50 min-w-25">
                                    <i
                                        class="mdi mdi-close-circle boton-cerrar-x"
                                        style="
                                            float: right;
                                            font-size: 25px;
                                            cursor: pointer;
                                        "
                                        @click="dialogNote = false"></i>
                                    <v-card-text class="text-center">
                                        ¿Estás seguro que quieres cancelar esta
                                        nota? Esta accion no puede deshacerse.
                                    </v-card-text>
                                    <v-card-actions class="justify-center">
                                        <v-btn
                                            color="#6c757d"
                                            @click="dialogNote = false"
                                            >Cerrar</v-btn
                                        >
                                        <v-btn color="red" @click="cancelNote()"
                                            >Revocar Nota</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-row>
                        </v-dialog>
                    </div>
                </div>
                <!-- Controles de paginación -->
                <v-pagination
                    v-model="currentPage"
                    :length="totalPages"></v-pagination>
            </div>
        </v-row>
    </div>
    <alertMessage ref="alertRef"></alertMessage>
</template>

<script>
import returnButton from '@/components/global/return-button.vue';
import patientInfo from '@/components/global/patient-info.vue';
import alertMessage from '@/components/global/alert-message.vue';
import { getPatientById } from '@/api/pacientes';
import { getNotes, putNotes, postNotes } from '@/api/notas';
import { memoizedGetPractitioner } from '@/api/practicante';

export default {
    components: {
        returnButton,
        alertMessage,
        patientInfo,
    },
    data() {
        const validCharsRegex =
            /^[a-zA-Z0-9\sñÑáéíóúÁÉÍÓÚüÜ,.;¡!¿?()@\-_*+/]*$/;
        return {
            note: '',
            snackbarMessage: null,
            mostrarItemsPaciente: [],
            notes: [],
            dialogNote: false,
            selectedNoteId: '',
            currentPage: 1,
            itemsPerPage: 3,
            selectedPatientId: '',
            practitionerId: '',
            reglasValidacion: [
                (v) => !!v || 'El campo es requerido',
                (v) => validCharsRegex.test(v) || 'Caracteres no permitidos',
            ],
            inputNoteForm: false,
            isSubmitting: false,
        };
    },
    created() {
        this.fetchNotes();
        this.selectedPatientId = this.$route.params.id;
        this.practitionerId = localStorage.getItem('id-user');
        this.fetchPatientDetails();
    },
    methods: {
        messageAlertSnackBar(message, status) {
            const alertConfig = {
                message: message,
                type: status,
            };
            this.$refs.alertRef.show(alertConfig);
        },
        sanitizarInput() {
            this.note = this.note.replace(
                /^[a-zA-Z0-9\sñÑáéíóúÁÉÍÓÚüÜ,.;¡!¿?()@\-_*+/]*$/,
                '',
            );
        },
        async createNote() {
            const data = {
                patient_id: `patient_models/${this.$route.params.id}`,
                practitioner_id: this.practitionerId,
                note: this.note,
                status: 'active',
            };

            try {
                if (this.isSubmitting) return;
                this.isSubmitting = true;

                const response = await postNotes(data);
                if (response.status == 200) {
                    this.messageAlertSnackBar(
                        'Nota creada con exito',
                        'success',
                    );
                    this.fetchNotes();
                    this.note = '';
                }
                this.isSubmitting = false;
            } catch (error) {
                this.messageAlertSnackBar('No se pudo crear nota', 'error');
                this.isSubmitting = false;
            }
        },
        openDialog(index) {
            this.selectedNoteId = this.notes[index]._key;
            this.dialogNote = true;
        },
        cancelNote() {
            try {
                const response = putNotes(this.selectedNoteId);
                if (response.status == 200) {
                    this.messageAlertSnackBar('Nota Cancelada', 'success');
                }
            } catch (error) {
                this.messageAlertSnackBar('No se pudo crear nota', 'error');
                console.error('Error al enviar la solicitud:', error);
            }
            this.fetchNotes();
            this.dialogNote = false;
        },
        fetchNotes() {
            getNotes(this.$route.params.id)
                .then(async (response) => {
                    await Promise.all(
                        response.map(async (note) => {
                            try {
                                const practitioner =
                                    await memoizedGetPractitioner(
                                        note.practitioner_id,
                                    );
                                const { name = [], lastname = [] } =
                                    practitioner || {};
                                note.practitioner = `${name[0] || ''} ${
                                    lastname[0] || ''
                                }${
                                    lastname[1] ? ' ' + lastname[1] : ''
                                }`.trim();
                            } catch (error) {
                                console.error(error.message);
                            }
                        }),
                    );

                    if (response.length === 0) {
                        this.snackbarMessage = 'No se encontraron notas';
                        this.messageAlertSnackBar(
                            'No se encontraron notas',
                            'warning',
                        );
                    }

                    this.notes = response;
                })
                .catch((error) => {
                    this.snackbarMessage =
                        'Se encontro un problema en el diagnóstico';
                    this.messageAlertSnackBar(error.message, 'error');
                });
        },
        fetchPatientDetails() {
            let id = this.$route.params.id;
            getPatientById(id)
                .then((patient) => {
                    this.mostrarItemsPaciente = [
                        { indicador: 'Nombre', valor: patient.nombre },
                        {
                            indicador: 'Apellido',
                            valor:
                                patient.primerApellido +
                                    ' ' +
                                    patient.segundoApellido ?? null,
                        },
                        {
                            indicador: 'Fecha de nacimiento',
                            valor: patient.birthdate,
                        },
                        { indicador: 'Edad', valor: patient.edad },
                        { indicador: 'Sexo', valor: patient.sexo },
                    ];
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        statusClass(status) {
            return {
                completed: status === 'actived',
                cancelled: status === 'cancelled',
            };
        },
        formatDate(dateString) {
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            };
            return new Date(dateString).toLocaleDateString('es-ES', options);
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
    },
    computed: {
        paginatedData() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.notes.slice(start, end);
        },
        totalPages() {
            return Math.ceil(this.notes.length / this.itemsPerPage);
        },
    },
};
</script>

<style scoped>
.notes-container {
    width: 100%;
    padding: 15px;
}

.note-item {
    background-color: #f7f7f7;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    width: 100%;
    position: relative;
    transition: all 0.3s ease;
}

.note-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
    border-bottom: 1px solid #ddd;
}

.info-group {
    display: flex;
    font-size: 1em;
    flex-direction: center;
    gap: 2px;
}

.info-text {
    color: #000000;
}

.practitioner-id {
    color: var(--color-principal);
    font-weight: 500;
    font-weight: bold;
}

.info-status {
    padding: 4px 8px;
    border-radius: 10px;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 0.75em;
    margin-left: 15px;
    margin-bottom: 6px;
    white-space: nowrap;
}

.note-content p {
    margin: 0;
    color: #000000;
    line-height: 1.6;
    font-size: 0.95em;
    padding-bottom: 10px;
}

.note-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #ddd;
    padding-top: 10px;
    font-size: 0.8em;
    color: #666;
}
/*














 */

/* Estados de las notas */
.completed {
    background-color: #c8e6c9;
    color: #256029;
}

.pending {
    background-color: #feedaf;
    color: #8a5340;
}

.urgent {
    background-color: #ffcdd2;
    color: #c63737;
}

/* Estilo para notas canceladas */
.cancelled-note {
    background-color: #f0f0f0;
    opacity: 0.8;
}

.cancelled-note * {
    color: #666 !important;
    text-decoration: line-through;
}

.cancelled-note .info-status {
    background-color: #e0e0e0 !important;
    color: #616161 !important;
}

/* Estilos del botón de cancelación */
.cancel-button {
    background-color: #ffebee;
    color: #c62828;
    border: 1px solid #c62828;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 0.8em;
    cursor: pointer;
    transition: all 0.3s ease;
}

.cancel-button:hover:not(:disabled) {
    background-color: #ffcdd2;
    border-color: #ef9a9a;
}

.cancel-button:disabled {
    background-color: #f5f5f5;
    color: #9e9e9e;
    border: 1px solid #9e9e9e;
    cursor: not-allowed;
    opacity: 0.7;
}

.date {
    font-style: italic;
    letter-spacing: 0.5px;
}

.error-message {
    color: var(--color-error);
    /* Cambia esto según tu estilo preferido */
    font-weight: bold;
    text-align: center;
}

.info-paciente {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;
}
</style>
